import { render } from "./RoomPage.vue?vue&type=template&id=017d1fa2"
import script from "./RoomPage.vue?vue&type=script&lang=js"
export * from "./RoomPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__